import { render, staticRenderFns } from "./LawyerServicesInfo.vue?vue&type=template&id=03bb06c1&"
import script from "./LawyerServicesInfo.vue?vue&type=script&lang=js&"
export * from "./LawyerServicesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports